import VueRouter from "vue-router";

// Shells
import AuthShell from "@/shells/AuthShell";
import GuestShell from "@/shells/GuestShell";

// Views
import Login from "@/views/Login";
import PageNotFound from "@/views/PageNotFound";
import Employee from "@/views/Employee";
import EmployeeForm from "@/views/EmployeeForm";
// import UnderDevelopment from "@/views/UnderDevelopment";
import Unit from "@/views/Unit";
import UnitForm from "@/views/UnitForm";
import Attendance from "@/views/Attendance";
import SettingForm from "@/views/SettingForm";
import Announcement from "@/views/Announcement";
import AnnouncementForm from "@/views/AnnouncementForm";
import Question from "@/views/Question";
import QuestionForm from "@/views/QuestionForm";
import Dashboard from "@/views/Dashboard";

// Auth Meta
const anyMeta = { auth: undefined };
const guestMeta = { auth: false };
const masterMeta = {
  auth: {
    roles: ["super-admin-profile", "admin-profile"],
    redirect: { name: "login" },
    forbiddenRedirect: "/403"
  }
};
const superAdminMeta = {
  auth: {
    roles: ["super-admin-profile"],
    redirect: { name: "login" },
    forbiddenRedirect: "/403"
  }
};

const router = new VueRouter({
  mode: process.env.NODE_ENV === "production" ? "history" : "hash",
  routes: [
    {
      path: "",
      component: AuthShell,
      children: [
        {
          path: "/",
          name: "dashboard",
          component: Dashboard,
          meta: masterMeta
        },
        {
          path: "attendance",
          name: "attendance",
          component: Attendance,
          meta: masterMeta
        },
        {
          path: "employee",
          name: "employee",
          component: Employee,
          meta: masterMeta
        },
        {
          path: "employee/create",
          name: "employee-create",
          component: EmployeeForm,
          meta: superAdminMeta
        },
        {
          path: "employee/:id/edit",
          name: "employee-edit",
          component: EmployeeForm,
          meta: masterMeta
        },
        {
          path: "unit",
          name: "unit",
          component: Unit,
          meta: masterMeta
        },
        {
          path: "announcement",
          name: "announcement",
          component: Announcement,
          meta: masterMeta
        },
        {
          path: "announcement/create",
          name: "announcement-create",
          component: AnnouncementForm,
          meta: masterMeta
        },
        {
          path: "announcement/:id/edit",
          name: "announcement-edit",
          component: AnnouncementForm,
          meta: masterMeta
        },
        {
          path: "question",
          name: "question",
          component: Question,
          meta: masterMeta
        },
        {
          path: "question/create",
          name: "question-create",
          component: QuestionForm,
          meta: masterMeta
        },
        {
          path: "question/:id/edit",
          name: "question-edit",
          component: QuestionForm,
          meta: masterMeta
        },
        {
          path: "unit/create",
          name: "unit-create",
          component: UnitForm,
          meta: masterMeta
        },
        {
          path: "unit/:id/edit",
          name: "unit-edit",
          component: UnitForm,
          meta: masterMeta
        },
        {
          path: "setting",
          name: "setting",
          component: SettingForm,
          meta: masterMeta
        }
      ]
    },
    {
      path: "",
      component: GuestShell,
      children: [
        {
          path: "/login",
          name: "login",
          component: Login,
          meta: guestMeta
        }
      ]
    },
    {
      path: "**",
      name: "PageNotFound",
      component: PageNotFound,
      meta: anyMeta
    }
  ]
});

export default router;
